var $ = global.jQuery = global.$;
var velocity = require('velocity-animate');
var Icon = require('./Icon');
var _Base = require('./_Base');

/**
 * Mobile navigation widget
 * @class
 * @extends _Base
 */
var MobileSubNavItem = _Base.extend(
  /** @lends MobileSubNavItem.prototype */
  {
  /**
   * Initialisation method
   * @private
   */
  init: function() {
    var self = this;
    this.$subnav = this.$el.find('[data-subnav-container]').eq(0);
    this.$subnavToggle = this.$el.find('[data-subnav-toggle]').eq(0);

    this.iconToggle = new Icon(this.$subnavToggle,{startIcon:'arrow-down',toggleIcon:'arrow-up'});

    this.close();

    this.$subnavToggle.on('click', function(event) {
      self.toggle();
    });
  },
  toggle: function() {
    if (this.isOpen) {
      this.close();
    } else {
      this.open();
    }
  },
  open: function() {
    var self = this;
    this.$el.addClass('is-open');
    this.iconToggle.change(this.iconToggle.toggleIcon);
    this.$subnav.velocity('slideDown',{
      complete: function() {
        self.isOpen = true;
      }
    });
  },
  close: function() {
    var self = this;
    this.$el.removeClass('is-open');
    this.iconToggle.change(this.iconToggle.startIcon);
    this.$subnav.velocity('slideUp',{
      complete: function() {
        self.isOpen = false;
      }
    });
  },
});

module.exports = MobileSubNavItem;



//////////////////
// WEBPACK FOOTER
// ./source/scripts/widgets/MobileSubNavItem.js
// module id = 272
// module chunks = 0